import React from "react";
import { Icon, SimpleGrid } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import Tab from "components/Tab";
import useTranslate from "hooks/useTranslate";
import StoreIcon from "components/StoreIcon";
import WardrobeIcon from "components/WardrobeIcon";
import V2Icon from "components/V2Icon";

const menuLinks = [
  {
    to: "/nfts",
    key: "tabs:nfts",
    icon: V2Icon,
  },
  {
    to: "/store",
    key: "tabs:store",
    icon: StoreIcon,
  },
  {
    to: "/wardrobe",
    key: "tabs:wardrobe",
    icon: WardrobeIcon,
  },
];

const MainMenu: React.FC = () => {
  const translate = useTranslate();

  return (
    <SimpleGrid columns={3}>
      {menuLinks.map(({ to, key, icon }) => (
        <NavLink key={to} to={to}>
          {({ isActive }) => (
            <Tab
              w="full"
              leftIcon={
                <Icon
                  as={icon}
                  w={{
                    base: "5",
                    sm: "6",
                  }}
                  h="auto"
                />
              }
              size="lg"
              isActive={isActive}
            >
              {translate(key)}
            </Tab>
          )}
        </NavLink>
      ))}
    </SimpleGrid>
  );
};

export default MainMenu;
